import { Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Constants } from 'src/app/shared/constants/constants.constant';
import { BaseComponent } from 'src/app/core/components/base.component';
import { NavigationConstants } from 'src/app/core/constants/navigation.constants';
import { AppContextService } from 'src/app/core/services/app-context.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { AppComponent } from '../../app.component';
import { MainComponent } from '../main/main.component';
import { SidebarConstants } from './Constants/sidebar.constants';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	standalone: false,
})
export class SidebarComponent extends BaseComponent implements OnInit {
	model: any[];

	constructor(
		public app: AppComponent,
		public appMain: MainComponent,
		appContext: AppContextService,
		private navigationService: NavigationService
	) {
		super(appContext);
		this.appContext.userChanged.pipe(takeUntil(this.destroyed$)).subscribe(x => this.refreshPage());
	}

	ngOnInit() {
		this.refreshPage();
	}

	onMenuClick() {
		this.appMain.menuClick = true;
	}

	showGlobalSearch(): boolean {
		return (
			this.appContext.userHasValidSubscription() &&
			(this.appContext.getUserRelationTypeCode() === Constants.UserRelationType.Subscriber ||
				this.appContext.getUserRelationTypeCode() === Constants.UserRelationType.Contractor)
		);
	}

	refreshPage() {
		if (this.appContext.userHasValidSubscription()) {
			if (this.appContext.isCustomerUser()) {
				this.model = this.getCustomerModel();
			} else {
				this.model = this.getModel();
			}
		} else {
			this.model = [];
		}
	}

	getModel(): any {
		const baseModel = {
			items: [
				{
					label: SidebarConstants.MenuLinks.DashBoard,
					icon: NavigationConstants.Icon_Dashboard,
					colorKey: 'default',
					permissionCode: Constants.UserPermission.DashboardView,
					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.DashBoard)],
				},
				{
					label: SidebarConstants.MenuLinks.ServiceRequests,
					icon: NavigationConstants.Icon_ServiceRequest,
					colorKey: Constants.RecordType.ServiceRequest,
					permissionCode: Constants.UserPermission.ServiceRequestView,
					userRelationTypeCode: [Constants.UserRelationType.Subscriber, Constants.UserRelationType.Client, Constants.UserRelationType.Contractor],
					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.ServiceRequests)],
				},
				{
					label: SidebarConstants.MenuLinks.Scopes,
					icon: NavigationConstants.Icon_Scope,
					colorKey: Constants.RecordType.Scope,
					permissionCode: Constants.UserPermission.ScopeView,
					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Scopes)],
				},
				{
					label: SidebarConstants.MenuLinks.Quotes,
					icon: NavigationConstants.Icon_QuoteRequest,
					colorKey: Constants.RecordType.QuoteRequest,
					permissionCode: Constants.UserPermission.QuoteView,
					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Quotes)],
				},
				{
					label: SidebarConstants.MenuLinks.WorkOrders,
					icon: NavigationConstants.Icon_WorkOrder,
					colorKey: Constants.RecordType.WorkOrder,
					permissionCode: Constants.UserPermission.WorkOrderView,
					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.WorkOrders)],
				},
				{
					label: SidebarConstants.MenuLinks.WOVariations,
					icon: NavigationConstants.Icon_WOVariations,
					colorKey: Constants.RecordType.WorkOrderVariation,
					permissionCode: Constants.UserPermission.WorkOrderVariationView,
					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.WOVariations)],
				},
				{
					label: SidebarConstants.MenuLinks.PurchaseOrders,
					icon: NavigationConstants.Icon_PurchaseOrder,
					colorKey: Constants.RecordType.PurchaseOrder,
					permissionCode: Constants.UserPermission.PurchaseOrderView,

					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.PurchaseOrders)],
				},
				{
					label: SidebarConstants.MenuLinks.Schedules,
					icon: NavigationConstants.Icon_Schedules,
					colorKey: Constants.RecordType.OrderSchedule,

					permissionCode: Constants.UserPermission.OrderScheduleView,
					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.OrderSchedules)],
				},
				{
					label: SidebarConstants.MenuLinks.Invoices,
					icon: NavigationConstants.Icon_Invoice,
					colorKey: Constants.RecordType.ReceivableInvoice,

					items: [
						{
							label: SidebarConstants.MenuLinks.Receivables,
							icon: this.isExternalUser ? NavigationConstants.Icon_PayableInvoice : NavigationConstants.Icon_ReceivableInvoice,
							colorKey: this.isExternalUser ? Constants.RecordType.PayableInvoice : Constants.RecordType.ReceivableInvoice,
							permissionCode: Constants.UserPermission.InvoiceView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Receivables)],
						},
						{
							label: SidebarConstants.MenuLinks.Payables,
							icon: this.isExternalUser ? NavigationConstants.Icon_ReceivableInvoice : NavigationConstants.Icon_PayableInvoice,
							colorKey: this.isExternalUser ? Constants.RecordType.ReceivableInvoice : Constants.RecordType.PayableInvoice,
							permissionCode: Constants.UserPermission.InvoiceView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Payables)],
						},
					],
				},
				{
					label: SidebarConstants.MenuLinks.Threads,
					icon: NavigationConstants.Icon_Threads,
					colorKey: 'default',
					permissionCode: Constants.UserPermission.CommonThreadRecordView,
					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Threads)],
				},
				{
					label: SidebarConstants.MenuLinks.Assets,
					icon: NavigationConstants.Icon_Asset,
					colorKey: Constants.RecordType.Asset,
					permissionCode: Constants.UserPermission.AssetView,
					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Assets)],
				},
				{
					label: SidebarConstants.MenuLinks.Properties,
					icon: NavigationConstants.Icon_Property,
					colorKey: Constants.RecordType.Property,
					permissionCode: Constants.UserPermission.AssetView,
					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Properties)],
				},
				{
					label: SidebarConstants.MenuLinks.Reports,
					icon: NavigationConstants.Icon_Report,
					colorKey: 'default',
					permissionCode: Constants.UserPermission.ReportView,
					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Reports)],
				},
				{
					label: SidebarConstants.MenuLinks.Calendar,
					icon: NavigationConstants.Icon_Calendar,
					colorKey: 'calendar',
					permissionCode: Constants.UserPermission.CalendarView,
					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Calendar)],
				},
				{
					label: SidebarConstants.MenuLinks.Contacts,
					icon: NavigationConstants.Icon_Contact,
					colorKey: 'contact',
					items: [
						{
							label: SidebarConstants.MenuLinks.Clients,
							icon: NavigationConstants.Icon_Client,
							permissionCode: Constants.UserPermission.ClientView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Clients)],
							colorKey: Constants.RecordType.Client,
						},
						{
							label: SidebarConstants.MenuLinks.Contractors,
							icon: NavigationConstants.Icon_Contractor,
							permissionCode: Constants.UserPermission.BusinessEntityView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Contractors)],
							colorKey: Constants.RecordType.Contractor,
						},
						{
							label: SidebarConstants.MenuLinks.ContractorWorkers,
							icon: NavigationConstants.Icon_ContractorWorker,
							permissionCode: Constants.UserPermission.BusinessEntityView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.ContractorWorkers)],
							colorKey: Constants.RecordType.ContractorWorker,
						},
						{
							label: SidebarConstants.MenuLinks.Employees,
							icon: NavigationConstants.Icon_Employee,
							permissionCode: Constants.UserPermission.BusinessEntityView,
							userRelationTypeCode: [Constants.UserRelationType.Subscriber],
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Employees)],
							colorKey: Constants.RecordType.Employee,
						},
						{
							label: SidebarConstants.MenuLinks.Suppliers,
							icon: NavigationConstants.Icon_Supplier,
							permissionCode: Constants.UserPermission.BusinessEntityView,
							userRelationTypeCode: [Constants.UserRelationType.Subscriber],
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Suppliers)],
							colorKey: Constants.RecordType.Supplier,
						},
					],
				},
				{
					label: SidebarConstants.MenuLinks.Rates,
					icon: NavigationConstants.Icon_Rates,
					colorKey: Constants.RecordType.Sor,
					items: [
						{
							label: SidebarConstants.MenuLinks.RateGroups,
							icon: NavigationConstants.Icon_RateGroup,
							permissionCode: Constants.UserPermission.SorView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.RateGroups)],
							colorKey: Constants.RecordType.Sor,
						},
						{
							label: SidebarConstants.MenuLinks.Items,
							icon: NavigationConstants.Icon_Item,
							permissionCode: Constants.UserPermission.SorView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Items)],
							colorKey: Constants.RecordType.Sor,
						},
						{
							label: SidebarConstants.MenuLinks.Problems,
							icon: NavigationConstants.Icon_Problem,
							permissionCode: Constants.UserPermission.SorView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Problems)],
							colorKey: Constants.RecordType.Sor,
						},
						{
							label: SidebarConstants.MenuLinks.CostPriceRules,
							icon: NavigationConstants.Icon_CostPriceRule,
							permissionCode: Constants.UserPermission.CostPriceRuleView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.CostPriceRules)],
							colorKey: Constants.RecordType.Sor,
						},
						{
							label: SidebarConstants.MenuLinks.SellPriceRules,
							icon: NavigationConstants.Icon_SellPriceRule,
							permissionCode: Constants.UserPermission.SellPriceRuleView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.SellPriceRules)],
							colorKey: Constants.RecordType.Sor,
						},
					],
				},
				{
					label: SidebarConstants.MenuLinks.Settings,
					icon: NavigationConstants.Icon_Settings,
					colorKey: 'default',
					items: [
						{
							label: SidebarConstants.MenuLinks.Companies,
							icon: NavigationConstants.Icon_Company,
							permissionCode: Constants.UserPermission.CompanyView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Companies)],
							colorKey: 'default',
						},
						{
							label: SidebarConstants.MenuLinks.FieldGroups,
							icon: NavigationConstants.Icon_FieldGroups,
							permissionCode: Constants.UserPermission.FieldGroupView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.FieldGroups)],
							colorKey: 'default',
						},
						{
							label: SidebarConstants.MenuLinks.Fields,
							icon: NavigationConstants.Icon_Field,
							permissionCode: Constants.UserPermission.DomainValueView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Fields)],
							colorKey: 'default',
						},
					],
				},
				{
					label: SidebarConstants.MenuLinks.SystemInterface,
					icon: NavigationConstants.Icon_SystemInterface,
					colorKey: 'default',
					items: [
						{
							label: SidebarConstants.MenuLinks.IncomingEvents,
							icon: NavigationConstants.Icon_IncomingEvent,
							permissionCode: Constants.UserPermission.InterfaceView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.IncomingEvents)],
							colorKey: 'default',
						},
						{
							label: SidebarConstants.MenuLinks.OutgoingEvents,
							icon: NavigationConstants.Icon_OutgoingEvent,
							permissionCode: Constants.UserPermission.InterfaceView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.OutgoingEvents)],
							colorKey: 'default',
						},
						{
							label: SidebarConstants.MenuLinks.IntegrationModules,
							icon: NavigationConstants.Icon_InterfaceModule,
							permissionCode: Constants.UserPermission.IntegrationModuleView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.IntegrationModules)],
							colorKey: 'default',
						},
					],
				},
				{
					label: SidebarConstants.MenuLinks.AccountAdmin,
					icon: NavigationConstants.Icon_AccountAdmin,
					colorKey: 'default',
					items: [
						{
							label: SidebarConstants.MenuLinks.SubscriberSettings,
							icon: NavigationConstants.Icon_SubscriberSettings,
							permissionCode: Constants.UserPermission.SubscriberView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.SubscriberSettings)],
							colorKey: 'default',
						},
						{
							label: SidebarConstants.MenuLinks.Users,
							icon: NavigationConstants.Icon_User,
							permissionCode: Constants.UserPermission.UserView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.Users)],
							colorKey: 'default',
						},
						{
							label: SidebarConstants.MenuLinks.ExternalUsers,
							icon: NavigationConstants.Icon_ExternalUser,
							permissionCode: Constants.UserPermission.ExternalUserView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.ExternalUsers)],
							colorKey: 'default',
						},
						{
							label: SidebarConstants.MenuLinks.UserRoles,
							icon: NavigationConstants.Icon_UserRole,
							permissionCode: Constants.UserPermission.UserRoleView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.UserRoles)],
							colorKey: 'default',
						},
						{
							label: SidebarConstants.MenuLinks.UserGroups,
							icon: NavigationConstants.Icon_UserGroup,
							permissionCode: Constants.UserPermission.UserGroupView,
							routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.UserGroups)],
							colorKey: 'default',
						},
					],
				},
				{
					label: SidebarConstants.MenuLinks.KnowledgeBase,
					icon: NavigationConstants.Icon_KnowledgeBase,
					url: 'https://spydertech.net.au/docs',
					permissionCode: null,
					target: '_blank',
					colorKey: 'spydertech',
				},
			],
		};

		if (environment.showDevHelpers) {
			baseModel.items.push(this.getsharedMenuLinks());
		}

		this.applyPermissions(baseModel);

		return baseModel.items;
	}

	getsharedMenuLinks(): any {
		return {
			label: SidebarConstants.MenuLinks.DevTools,
			icon: NavigationConstants.Icon_DevTools,
			colorKey: 'default',
			permissionCode: null,
			routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.MenuLinks.DevTools)],
		};
	}

	getCustomerModel(): any {
		const baseModel = {
			items: [
				{
					label: SidebarConstants.CustomerMenuLinks.CustomerDashBoard,
					icon: NavigationConstants.Icon_CustomerDashboard,
					colorKey: 'default',
					permissionCode: Constants.UserPermission.CustomerDashboardView,
					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.CustomerMenuLinks.CustomerDashBoard)],
				},
				{
					label: SidebarConstants.CustomerMenuLinks.CustomerRequests,
					icon: NavigationConstants.Icon_CustomerRequest,
					colorKey: Constants.RecordType.CustomerRequest,
					permissionCode: Constants.UserPermission.CustomerRequestView,
					routerLink: [this.navigationService.getCustomerMenuLinkNavigation(SidebarConstants.CustomerMenuLinks.CustomerRequests)],
				},
				{
					label: SidebarConstants.CustomerMenuLinks.CustomerProperties,
					icon: NavigationConstants.Icon_Property,
					colorKey: Constants.RecordType.Property,
					permissionCode: Constants.UserPermission.CustomerAssetView,
					routerLink: [this.navigationService.getCustomerMenuLinkNavigation(SidebarConstants.CustomerMenuLinks.CustomerProperties)],
				},
				{
					label: SidebarConstants.CustomerMenuLinks.CustomerAssets,
					icon: NavigationConstants.Icon_Asset,
					colorKey: Constants.RecordType.Asset,
					permissionCode: Constants.UserPermission.CustomerAssetView,
					routerLink: [this.navigationService.getMenuLinkNavigation(SidebarConstants.CustomerMenuLinks.CustomerAssets)],
				},
				{
					label: SidebarConstants.CustomerMenuLinks.CustomerCalendar,
					icon: NavigationConstants.Icon_CustomerCalendar,
					colorKey: 'calendar',
					permissionCode: Constants.UserPermission.CalendarViewBasic,
					routerLink: [this.navigationService.getCustomerMenuLinkNavigation(SidebarConstants.CustomerMenuLinks.CustomerCalendar)],
				},
				{
					label: SidebarConstants.MenuLinks.KnowledgeBase,
					icon: NavigationConstants.Icon_KnowledgeBase,
					url: 'https://spydertech.net.au/docs',
					permissionCode: null,
					target: '_blank',
					colorKey: 'spydertech',
				},
			],
		};

		if (environment.showDevHelpers) {
			baseModel.items.push(this.getsharedMenuLinks());
		}

		this.applyPermissions(baseModel);

		return baseModel.items;
	}

	applyPermissions(model: any) {
		if (model.items == null) return;

		// top-level filter first
		model.items = model.items
			.filter(x => this.appContext.hasPermission(x.permissionCode))
			.filter(
				x =>
					x.userRelationTypeCode == undefined ||
					(Array.isArray(x.userRelationTypeCode)
						? x.userRelationTypeCode.some((code: string) => this.appContext.isUserType(code))
						: this.appContext.isUserType(x.userRelationTypeCode))
			);

		// then check individual items
		model.items.forEach(x => this.applyPermissions(x));

		// then re-filter for empty sub-item list
		model.items = model.items.filter(x => x.items == null || x.items.length > 0);
	}
}
